
/**
 * The purpose of this is file is to share variables between
 * CSS and JS. E.g.
 * 	In css: $primaryColor
 * 	in JS:
 * 		let variables = require('./variables.js');
 * 		console.log(variables.primaryColor);
 *
 * Note that PostCSS does not allow you to read properties of
 * variables so values must be simple (string, numbers, ...)
 * and not objects.
 */
module.exports = {
	screen_wrapper:			'1188px',
	screen_mobileMenu: 		'930px',
	screen_stackPlauditQuery: '800px',
	screen_stackFormArea:	'800px',
	screen_medium:			'986px',
	screen_tablet: 			'768px',
	screen_smallest:		'393px'
};
